import { JobData, ProjectState } from './types';

export const initialState: JobData = {
  open: false,
  initialDate: undefined,
  job: {},
  task: {},
  tasks: [],
};

export const initialProjectState: ProjectState = {
  showArchivedJobs: true,
};
